import Box from '@mui/material/Box';

const NotFoundPage = () => {
  return <Box>404 Page not found.</Box>;
};

export default NotFoundPage;
